import { Capacitor } from "@capacitor/core";

// "web" | "android" | "ios" — the ONE source of truth for platform-dependent payment rules.
export const appPlatform = () => {
  try {
    if (typeof Capacitor?.isNativePlatform === "function" && !Capacitor.isNativePlatform()) return "web";
    const p = typeof Capacitor?.getPlatform === "function" ? Capacitor.getPlatform() : "web";
    return p === "ios" || p === "android" ? p : "web";
  } catch {
    return "web";
  }
};

export const isNativeApp = () => appPlatform() !== "web";

// Phone-style navigation (bottom tabs, centered « + », ☰ drawer) on EVERY native screen,
// tablets included: an iPad must feel like the mobile app, never like the website.
// Web keeps its responsive breakpoints. QA seam (dev only): localStorage yalola.qa_phone_nav=1.
export const phoneNav = () => {
  if (isNativeApp()) return true;
  try { return process.env.NODE_ENV !== "production" && localStorage.getItem("yalola.qa_phone_nav") === "1"; } catch { return false; }
};
